import Api from './Api';
import { AssetListModel } from '../models/AssetListModel';
import { PlaceListModel } from '../models/PlaceListModel';

function unwrapList<T>(body: any): T[] {
  if (Array.isArray(body)) return body as T[];
  if (Array.isArray(body?.items)) return body.items as T[];
  if (Array.isArray(body?.data)) return body.data as T[];
  if (Array.isArray(body?.values)) return body.values as T[];
  return [];
}

class AnalyticsService {
  getAssets = async (top = 1000): Promise<AssetListModel[]> => {
    const res = await Api.get(`/assets?skip=0&top=${top}&filter=`);
    return unwrapList<AssetListModel>(res.data);
  };

  getPlaces = async (take = 500): Promise<PlaceListModel[]> => {
    const res = await Api.post('v2/places/filtered', {
      condition: 'and',
      filters: [],
      sorts: [{ field: 'name', ascending: true }],
      fields: [],
      skip: 0,
      take,
    });
    return unwrapList<PlaceListModel>(res.data);
  };

  getAllAssets = async (take = 2000): Promise<any[]> => {
    const res = await Api.post('/v2/assets/filter/', {
      skip: 0,
      take,
      filters: [{ field: 'active', type: 'equals', filter: 'true' }],
      sorts: [{ field: 'name', ascending: true }],
      fields: [],
      search: '',
      condition: 'and',
    });
    return unwrapList<any>(res.data);
  };

  getPlaceAssets = async (placeId: number, take = 500): Promise<any[]> => {
    const res = await Api.post('/v2/assets/filter/', {
      skip: 0,
      take,
      filters: [
        { field: 'active', type: 'equals', filter: 'true' },
        { field: 'placeId', type: 'equal', filter: String(placeId) },
      ],
      sorts: [{ field: 'name', ascending: true }],
      fields: [],
      search: '',
      condition: 'and',
    });
    return unwrapList<any>(res.data);
  };

  getBeaconReadings = async (
    beaconId: number,
    abilityId: number,
    start: string,
    end: string,
  ): Promise<any[]> => {
    const res = await Api.get(
      `/beacons/${beaconId}/readings/${abilityId}?start=${start}&end=${end}`,
    );
    return unwrapList<any>(res.data);
  };
}

const analyticsService = new AnalyticsService();
export { AnalyticsService, analyticsService };
export default analyticsService;
